import { makeSelectors } from '@utils/css';

const BUTTON_FADE_DURATION_MS = 100;
const KARAOKE_TRANSITION_DURATION_MS = 100;
const PROGRESS_STROKE_WIDTH_PX = 2;
const BUTTON_SIZE_PX = 50;
const BUTTON_MOBILE_SIZE_PX = 44;
const buttonWrapperCls = "dibbv6hwg1";
const buttonCls = "dibb1orxgb8";
const guideBubbleCls = "dibg1fi3iqr";
const iconCls = "dibijg1o87";
const loaderCls = "diblod343h";
const progressCls = "dibpx1o3qq";
const flagButtonsCls = "dibf1m9oh1f";
const karaokeHighlightCls = "dibk13mtzn8";
const speechKaraokeSelectors = makeSelectors({
  highlightNode: karaokeHighlightCls
});

export { BUTTON_FADE_DURATION_MS, BUTTON_MOBILE_SIZE_PX, BUTTON_SIZE_PX, KARAOKE_TRANSITION_DURATION_MS, PROGRESS_STROKE_WIDTH_PX, buttonCls, buttonWrapperCls, flagButtonsCls, guideBubbleCls, iconCls, karaokeHighlightCls, loaderCls, progressCls, speechKaraokeSelectors };
import "./speech-button.style.linaria.module.css";
//# sourceMappingURL=speech-button.style.js.map
